module.exports = __webpack_public_path__ + "static/media/hackers_speakenglish.f40d6266.gif";